module.exports = __webpack_public_path__ + "img/marineArea.6b5fa85f.png";